import React from "react";
import "@/App.css";

import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Intro from "@/components/site/Intro";
import Why from "@/components/site/Why";
import Ranges from "@/components/site/Ranges";
import Applications from "@/components/site/Applications";
import Sustainability from "@/components/site/Sustainability";
import Founder from "@/components/site/Founder";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function App() {
  return (
    <div className="rf-page" data-testid="renaflex-page">
      <Header />
      <main>
        <Hero />
        <Intro />
        <Why />
        <Ranges />
        <Applications />
        <Sustainability />
        <Founder />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
